import { render, staticRenderFns } from "./ReviewWithPics.vue?vue&type=template&id=01359355&scoped=true"
import script from "./ReviewWithPics.vue?vue&type=script&lang=js"
export * from "./ReviewWithPics.vue?vue&type=script&lang=js"
import style0 from "./ReviewWithPics.vue?vue&type=style&index=0&id=01359355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01359355",
  null
  
)

export default component.exports